import { Popper, PopperProps } from "@mui/material";

export interface CustomPopperProps extends PopperProps {
	width?: number | string;
}

export const CustomPopper = ({ width, style, ...other }: CustomPopperProps) => {
	return (
		<Popper
			{...other}
			style={{
				...style,
				width: width,
				maxWidth: "100vw",
			}}
			placement="bottom-start"
		/>
	);
};
